module.exports = __webpack_public_path__ + "static/media/pdp_paperTripleThick.4968ab44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_paperTripleThick.jpg
// module id = 985
// module chunks = 47